module.exports = __webpack_public_path__ + "img/imgSrc55.9fb78da5.png";